export { default as Toggle } from 'depreciations/components/list/actions/DepreciationsActionsToggle';
export { default as Edit } from 'depreciations/components/list/actions/DepreciationsActionsEdit';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/list/actions/index.js